import React, { Component } from 'react';

import SidebarMenu from '../layout/SidebarMenu';
import Content from './termsOfService/Content';


const menuItems = [{
  id: 'terms-of-use',
  label: 'Terms of Use',
  icon: 'tos'
}, {
  id: 'privacy-policy',
  label: 'Privacy Policy',
  icon: 'privacy'
}];

class TermsOfService extends Component {
  componentDidMount() {
    if (window.location.hash === '#privacy_policy') {
      this.scrollToItem('privacy-policy');
    }
  }

  render() {
    return (
      <div className="terms-of-service">
        <div className="with-sidebar-layout">

          <div className="sidebar">
            <SidebarMenu
              items={menuItems}
              onItemClick={this.onItemClick.bind(this)}
            />
          </div>

          <div className="content">
            <Content />
          </div>

        </div>
      </div>
    );
  }

  onItemClick(id) {
    this.scrollToItem(id, true);
  }

  scrollToItem(id, smooth = false) {
    const element = document.getElementById(id);

    if (!element) { return; }

    const offset = 20;
    const elementPosition = window.pageYOffset + element.getBoundingClientRect().top;
    const targetPositon = elementPosition - offset;

    window.scrollTo({ top: targetPositon, behavior: smooth ? 'smooth' : 'auto' });
  }
}

TermsOfService.defaultProps = {};

TermsOfService.propTypes = {};

export default TermsOfService;
